export enum AuthType {
  socialNetwork,
  emailAndPassword,
}
